export default (formId) => (state) => state.forms[formId];
